import { render, staticRenderFns } from "./InvoiceMerchantContact.vue?vue&type=template&id=5a936e94&scoped=true&"
import script from "./InvoiceMerchantContact.vue?vue&type=script&lang=ts&"
export * from "./InvoiceMerchantContact.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceMerchantContact.vue?vue&type=style&index=0&id=5a936e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a936e94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VDatePicker,VImg,VMenu,VRow,VSpacer,VTextField})
